<form [formGroup]="searchForm" (ngSubmit)="onSearch()" id="gtm-search-refine-form">
    <input type="text" id="searchInput" formControlName="q" class="selenium-search-input" />
    <button class="btn btn-primary selenium-search-button" type="submit">
        Search
        <i class="fa fa-search"></i>
    </button>
</form>
